import React from 'react';
import { useTheme } from '@zydalabs/storefront-components';
import { Typography } from '@zydalabs/zac-react';

import { InfoCardWrapper, CardInfo } from './style';

type InfoCardType = {
  text: string;
  subText: string;
  textVariant?: string;
  subTextVariant?: string;
  textColor?: string;
  subTextColor?: string;
  backGroundColor?: string;
  isBorder?: boolean;
};

const InfoCard: React.FC<InfoCardType> = ({
  text,
  subText,
  textVariant,
  subTextVariant,
  textColor,
  subTextColor,
  backGroundColor,
  isBorder,
}) => {
  const theme: any = useTheme();
  return (
    <InfoCardWrapper backGroundColor={backGroundColor} isBorder={isBorder}>
      <CardInfo>
        <Typography
          variant={textVariant ? 'heading18' : 'body16'}
          color={textColor ?? theme.color.black}
          mb={4}
          mt={0}
          testId="info-text"
        >
          {text}
        </Typography>
        <div>
          <Typography
            variant={subTextVariant ? 'body14' : 'body16'}
            color={subTextColor ?? theme.color.disabled}
            testId="info-subText"
          >
            {subText}
          </Typography>
        </div>
      </CardInfo>
    </InfoCardWrapper>
  );
};

export default InfoCard;
